var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M17.786 9.168c0-.737-.06-1.275-.19-1.833h-8.42v3.328h4.942c-.1.827-.638 2.073-1.834 2.91l-.016.112 2.662 2.062.185.019c1.694-1.565 2.67-3.867 2.67-6.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M9.175 17.938c2.422 0 4.455-.797 5.94-2.172l-2.83-2.193c-.758.528-1.774.897-3.11.897-2.372 0-4.385-1.565-5.102-3.727l-.105.009-2.769 2.143-.036.1a8.96 8.96 0 0 0 8.012 4.943"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M4.073 10.743a5.5 5.5 0 0 1-.3-1.774c0-.618.11-1.216.29-1.774l-.005-.119L1.254 4.9l-.091.044a9 9 0 0 0-.957 4.026c0 1.445.349 2.81.957 4.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M9.175 3.468c1.684 0 2.82.728 3.468 1.335l2.531-2.471C13.62.887 11.598 0 9.176 0a8.96 8.96 0 0 0-8.012 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgGoogleIcon;